import { useLazyQuery, useMutation, useQuery } from "@apollo/react-hooks";
import { loadStripe } from "@stripe/stripe-js";
import {
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  Elements,
  useElements,
} from "@stripe/react-stripe-js";
import {
  Button,
  Col,
  Row,
  Typography,
  Divider,
  Input,
  Form,
  Tooltip,
  Checkbox,
  message,
} from "antd";
import * as moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import PaymentImage from "../../../../../Assets/Images/006.jpg";
import PaymentMethods from "../../../../../Assets/Images/stripe.png";
import logo from "../../../../../Assets/Images/logo_copy.png";
import { Loader } from "../../../../../Components/Loader";
import { SuccessPaymentModal } from "../../../../../Components/Modals/SuccessPaymentModal";
import { CustIcon } from "../../../../../Components/Svgs";
import {
  CREATE_PAYMENT_INTENT,
  GET_BUSINESS_BY_OWNER,
  GET_CUSTOMER_TRANSACTION,
} from "../../../../../Graphql/queries";
import { ADD_CARD } from "../../../../../Graphql/mutations";
import "./Transaction.less";
const { Title } = Typography;

export const TransactionPage = (props) => {
  // const { state: stateParams } = useLocation();
  const history = useHistory();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [form] = Form.useForm();
  const stripe = useStripe();
  const elements = useElements();

  const [INSERT_CARD, { loading: isInserPayLoading }] = useMutation(ADD_CARD);

  const { data: businessData, loading: businessDataLoading } = useQuery(
    GET_BUSINESS_BY_OWNER,
    {
      variables: {
        owner_id: localStorage.getItem("user_id"),
      },
      fetchPolicy: "cache-and-network",
      context: {
        headers: {
          subscription: 1,
        },
      },
    }
  );

  const { data: customerTransaction, loading: customerTransactionLoading } =
    useQuery(GET_CUSTOMER_TRANSACTION, {
      variables: {
        user_id: localStorage.getItem("user_id"),
      },
      fetchPolicy: "cache-and-network",
      context: {
        headers: {
          subscription: 1,
        },
      },
    });

  useEffect(() => {
    if (businessData) {
      form.setFieldsValue({
        email: businessData.business[0].owner.email,
      });
    }
    if (customerTransaction) {
      if (customerTransaction.user_subscription.length > 0) {
        history.push("/on-boarding/location");
      }
    }
  }, [businessData, customerTransaction]);

  const layout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const onAddTransaction = async (ev) => {
    try {
      let additionalData = {
        name: `${ev.name} ${ev.lname}`,
        line1: ev.Address,
        line2: "",
        country: ev.Country,
        city: ev.City,
        state: ev.State,
        postal_code: ev.Zipcode,
        email: ev.email,
        locations: props?.data?.locations,
        priceId: props?.data?.price_id,
        user_id: localStorage.getItem("user_id"),
        card_name: ev.card_name,
      };
      if (!stripe || !elements) {
        return;
      }

      const response = await stripe.createToken(
        elements.getElement(CardNumberElement),
        {
          name: `${ev.card_name}`,
          line1: ev.Address,
          line2: "",
          country: ev.Country,
          city: ev.City,
          state: ev.State,
          postal_code: ev.Zipcode,
          email: ev.email,
          locations: props?.data?.locations,
          priceId: props?.data?.price_id,
          user_id: localStorage.getItem("user_id"),
        }
      );

      if (response?.error || response?.token?.error) {
        message.error(response?.error?.message || response?.token?.error);
      } else {
        additionalData.token = response.token.id;
        const isInsertSuccessful = await INSERT_CARD({
          variables: {
            stripe_data: additionalData,
          },
        });

        if (isInsertSuccessful.data?.add_card?.status === "200") {
          setShowSuccessModal(true);
        } else if (
          isInsertSuccessful.data?.add_card?.message ===
          "Customer already exist!"
        ) {
          message.error(
            "Customer email already exist, please try different email!"
          );
        } else {
          message.error("Payment Failed...");
        }
      }
    } catch (error) {}
  };
  const style = {
    empty: {},
    base: {
      color: "#000",
      fontFamily: "poppins, sans-serif",
      fontSmoothing: "antialiased",
      fontSize: 15,
      "::placeholder": {
        color: "#92929ec2",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  };

  const numberElement = {
    style: style,
    placeholder: "Card Number",
    showIcon: true,
  };
  const expiryElement = {
    style: style,
    placeholder: "MM / YY",
  };
  const cvvElement = {
    style: style,
    placeholder: "CVV / CVC",
  };
  const handleChange = async (event) => {
    // Listen for changes in the CardElement
    // and display any errors as the customer types their card details
    // setDisabled(event.empty);
    // setError(event.error ? event.error.message : "");
  };
  return (
    <div className="rowSec">
      <SuccessPaymentModal visible={showSuccessModal} />
      <div className="colSec onBoardingLeft">
        <img src={PaymentImage} alt="" className="" />
      </div>
      <div className="colSec onBoardingRight">
        {businessDataLoading ? (
          <Loader />
        ) : (
          <div className="step_2">
            <p className="text-right text-step">Step 6 of 6</p>
            <Title level={2}>
              <CustIcon type="left-arrow" onClick={() => history.goBack()} />
              Pay with your card
            </Title>
            {/* <form id="payment-form" onSubmit={onAddTransaction}> */}
            <Form
              {...layout}
              id="card-element"
              name="basic"
              form={form}
              onFinish={(e) => onAddTransaction(e)}
            >
              <Row className="mt-0 mx-0" gutter={16}>
                <Col xs={24} sm={12}>
                  <img src={PaymentMethods} className="payByImg" alt="" />
                </Col>
                <Col xs={24} sm={12}>
                  <img
                    src={logo}
                    className="payByImg"
                    alt=""
                    style={{ float: "right" }}
                  />
                </Col>
                <Col xs={24} sm={24}>
                  <Divider className="text-black mt-0">
                    Billing Information
                  </Divider>
                </Col>
                <Col xs={24} sm={24}>
                  <div className="trialText">First 30-days is a free trial. Your card will be charged after 30-day free trial ends. We do not store your card information.</div>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={<Fragment>Name</Fragment>}
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Please enter name!",
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input placeholder="e.g, John." />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={<Fragment></Fragment>}
                    name="lname"
                    rules={[
                      {
                        required: true,
                        message: "Please enter last name!",
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input placeholder="e.g, Doe." />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24}>
                  <Form.Item
                    label={<Fragment>Email</Fragment>}
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please enter email!",
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input placeholder="e.g, abc@xyz.com" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24}>
                  <Form.Item
                    label={<Fragment>Address</Fragment>}
                    name="Address"
                    rules={[
                      {
                        required: true,
                        message: "Please enter address!",
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input placeholder="e.g, 127 Adam Drive" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={<Fragment>Zipcode</Fragment>}
                    name="Zipcode"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Zipcode!",
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input placeholder="e.g, 123456" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={<Fragment>City</Fragment>}
                    name="City"
                    rules={[
                      {
                        required: true,
                        message: "Please enter city!",
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input placeholder="e.g, New York" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={<Fragment>State</Fragment>}
                    name="State"
                    rules={[
                      {
                        required: true,
                        message: "Please enter state!",
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input placeholder="e.g, CA" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={<Fragment>Country</Fragment>}
                    name="Country"
                    rules={[
                      {
                        required: true,
                        message: "Please enter country!",
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input placeholder="e.g, United States" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24}>
                  <Divider className="text-black mt-0">
                    Payment Information
                  </Divider>
                </Col>
                <Col xs={24} sm={24}>
                  <Form.Item
                    label={<Fragment>Card number</Fragment>}
                    name="Card number"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Please enter card number!",
                    //     whitespace: false,
                    //   },
                    // ]}
                  >
                    <div className="inputCard">
                      {" "}
                      <CardNumberElement
                        id="card-element1"
                        options={numberElement}
                        onChange={handleChange}
                      />{" "}
                    </div>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={<Fragment>Expiry</Fragment>}
                    name="Expiry"
                    // rules={[
                    //   {
                    //     required: false,
                    //     message: "Please enter expiry!",
                    //     whitespace: true,
                    //   },
                    // ]}
                  >
                    <div className="inputCard">
                      {" "}
                      <CardExpiryElement
                        id="card-element2"
                        options={expiryElement}
                        onChange={handleChange}
                      />{" "}
                    </div>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label={<Fragment>CVV/CVC</Fragment>}
                    name="CVV/CVC"
                    // rules={[
                    //   {
                    //     required: false,
                    //     message: "Please enter cvv!",
                    //     whitespace: true,
                    //   },
                    // ]}
                  >
                    <div className="inputCard">
                      {" "}
                      <CardCvcElement
                        id="card-element3"
                        options={cvvElement}
                        onChange={handleChange}
                      />{" "}
                    </div>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24}>
                  <Form.Item
                    label={<Fragment>Name on card</Fragment>}
                    name="card_name"
                    rules={[
                      {
                        required: true,
                        message: "Please enter name!",
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input placeholder="e.g, John Doe" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24}>
                  <Form.Item
                    name="terms"
                    valuePropName="checked"
                    rules={[
                      {
                        validator: (_, value) =>
                          value
                            ? Promise.resolve()
                            : Promise.reject(
                                new Error("Please accept terms and conditions")
                              ),
                      },
                    ]}
                  >
                    <Checkbox className="typeCheckboxGroup">
                      I agree with Stripe
                      <Button
                        className="p-1"
                        type="link"
                        onClick={() =>
                          window.open("https://sanattest.com/terms-conditions/")
                        }
                      >
                        Terms and Conditions
                      </Button>
                    </Checkbox>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24}>
                  <Form.Item className="buttonSec pt-2">
                    <Button
                      type="primary"
                      shape="round"
                      size="large"
                      htmlType="submit"
                      loading={isInserPayLoading}
                    >
                      Pay
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
          // </Elements>
        )}
      </div>
    </div>
  );
};
